import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  products: null,
  singleSubmitLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PRODUCT_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
